export default __webpack_public_path__ + "static/pic01-d8c87fc2a2411e5715b6b6dc651a1627.svg";